import router from '@router'
import axios from 'axios'
import { UserAgentApplication } from "msal";
import store from '@store'
import { AUTH_REQUEST } from '@/store/actions/auth'
import apiHelper from '@api/helper'
import moment from 'moment'
var msalInstance = null
var accessToken = null

const getTokenLogOn  = () => {
  if(!process.env.HAS_LOGIN) {
    return
  }
  store.dispatch('toggleAuthLoading',false)
  const loginRequest = {
    state: '1234'
  }
  console.error('loginRequest' , loginRequest)
  msalInstance.loginRedirect(loginRequest);
}

const authCallback = function (error, response) {
  if(response) {
    console.error('authCallback' , error,response)
  }
  // handle error or response
}

const initMsal = async () => {
  console.error('initMsal')
  var msalConfig = {
    auth: {
        clientId: process.env.CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.TENANT_ID}/`,
        redirectUri: process.env.REDIRECT_URL
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  };
  msalInstance = new  UserAgentApplication(msalConfig);
  // create callback for redirect function

  // register redirect call backs for Success and Error
  msalInstance.handleRedirectCallback(authCallback);
  if(process.env.HAS_LOGIN) {
    let account = msalInstance.getAccount()
    if (account) {
      console.error('user authen', account)
      if(process.env.IS_REQUIRE_ACCESSTOKEN) { 
        await getAccessToken()
      } else {
        await getPassport() // get passport no get detail in graph
      }
    } else {
      console.error('user not authen')
      getTokenLogOn()
    }
  } else {
    await getPassport() // get passport mock api
  }
}
const getAccessToken = async () => {
  let account = msalInstance.getAccount()
  console.error('getAccessToken account', account)
  const identity = account ? (account.idToken ?  account.idToken.preferred_username : '') : account.userName
  let request = {
    scopes: ["user.read","directory.read.all"],
    state: '1234',
    loginHint: identity
  }
  await msalInstance.acquireTokenSilent(request).then(async(response) =>{
    accessToken = response.accessToken
    sessionStorage.setItem('access-token', accessToken)
    startWorker(response.expiresOn)
    // get passport in app after get access token success 
    await getPassport()
  }).catch(async (error) => {
    console.error('catch acquireTokenSilent'  , error)
    store.dispatch('toggleAuthLoading',true )
    router.push({name: '401'})
  });
}

// create axios 
const getAxiosInstance = () => {
  // axios
  const axiosInstance = axios.create({
    baseURL: process.env.GRAPH_ENDPOINT,
    headers: {
      'Content-Type': ' application/json',
      'Cache-Control': 'no-cache'
    }
  })
  axiosInstance.interceptors.request.use(config => {
    config.headers['Authorization'] = accessToken ? `BEARER ${accessToken}` : ''
    return config
  }, (error) => {
    console.log('Intercepter Error:', error)
    throw error
  })
  axiosInstance.interceptors.response.use(config => {
    return config
  }, (error) => {
    console.error('axiosInstance error ' , error)
    let response = error.response
    if(response) {
      if (error.response.status === 401)
        getAccessToken()
    }
    throw error
  })
  return axiosInstance
}

const getPassport = async () => {
  await store.dispatch(AUTH_REQUEST, {}).then(res => {
    console.info('AUTH_REQUEST ->>> success' ,res)
    store.dispatch('toggleAuthLoading',true )
  }).catch(err => {
    console.info('AUTH_REQUEST ->>> error' ,err)
    store.dispatch('toggleAuthLoading',true )
    router.push({name: '401'})
  })
}
const to = async (promise) => {
  return await promise.then(res => {
    let data = res.data
    return {
      error: null,
      data: data.value
    }
  })
  .catch(err => {
    return {
      error: err
    }
  })
}
const tryGet = async (promise) => {
  return await promise.then(res => {
    let data = res.data
    if(data.responseStatus.responseCode === 'SUCCESS') {
      return {
        error: null,
        data: data.responseData
      }
    } else {
      return {
        error: data.responseStatus.responseMessage
      }
    }
  })
  .catch(err => {
    return {
      error: err
    }
  })
}
// call graph
const getMe = async () => {
  return await to(getAxiosInstance().get("me"));
}
const getMemberFilter = async (searchTxt) => {
  if(!process.env.IS_REQUIRE_ACCESSTOKEN) {
    // call backend
    let {error , data} = await tryGet(apiHelper.user.getGraphUser(searchTxt))
    return {
      error: error,
      data: data.value
    }
  }
  // call microsoft graph
  let limitResult = 10;
  let queryFilters = `$filter=startswith(displayName,'${searchTxt}') or startswith(userPrincipalName,'${searchTxt}')&$top=${limitResult}`
  return await to(getAxiosInstance().get(`users?${queryFilters}`))
}
const getGroupByName = async (searchTxt) => {
  if(!process.env.IS_REQUIRE_ACCESSTOKEN) {
    // call backend
    let {error , data} = await tryGet(apiHelper.user.getGraphGroup(searchTxt))
    return {
      error: error,
      data: data.value
    }
  }
  // call microsoft graph
  let limitResult = 10;
  let queryFilters = `$filter=startswith(displayName,'${searchTxt}')&$top=${limitResult}`
  return await to(getAxiosInstance().get(`groups?${queryFilters}`));
}
var worker = undefined
const startWorker = (exp) => {
  if(worker)
    clearInterval(worker)
  console.debug('startWorker')
  let timeNbf = moment(exp).subtract('minutes', 5)
  let intervalTime = (1000 * 60) // millisec
  worker = setInterval(() => {
    let timeCurrent = moment(new Date())
    console.debug('run background' ,exp, timeNbf, timeCurrent)
    if(timeCurrent.isSameOrAfter(timeNbf)) {
      stopWorker()
      console.debug('renew accessToken')
      getAccessToken()
    }
  }, intervalTime);
}
const stopWorker = () => {
  console.debug('stopWorker')
  if(worker) {
    clearInterval(worker)
    worker = undefined
  }
}
// add function to graph group
const graph = {
  getMe: getMe,
  getMemberFilter: getMemberFilter,
  getGroupByName: getGroupByName
}
const msalGlobal = { getTokenLogOn, initMsal , graph, getPassport }
export default msalGlobal